import { SDKError } from "@smash-sdk/core";
export class GenericError extends SDKError {
}
export class InvalidVatNumberError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidVatNumberError";
    }
}
export class InvalidParameterError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidParameterError";
    }
}
export class UnauthorizedError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "UnauthorizedError";
    }
}
export class VatNumberNotUpdatableError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "VatNumberNotUpdatableError";
    }
}
export class ForbiddenError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "ForbiddenError";
    }
}
export class NotFoundError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "NotFoundError";
    }
}
export class InternalServerError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InternalServerError";
    }
}
export class ServiceUnavailableError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "ServiceUnavailableError";
    }
}
export class BadGatewayError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "BadGatewayError";
    }
}
export class GatewayTimeoutError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "GatewayTimeoutError";
    }
}
export default {
    GenericError,
    InvalidVatNumberError,
    InvalidParameterError,
    UnauthorizedError,
    VatNumberNotUpdatableError,
    ForbiddenError,
    NotFoundError,
    InternalServerError,
    ServiceUnavailableError,
    BadGatewayError,
    GatewayTimeoutError,
};
